import { useQuery } from "@tanstack/react-query";
import { getSeries, getSeriesDetail, getBudgets, getBudgetDetail, getAllocationSources } from "./api";

export function useSeries(group, horizon, enabled = true) {
  return useQuery({
    queryKey: ["fx-series", group, horizon],
    queryFn: () => getSeries(group, horizon),
    enabled,
    refetchOnWindowFocus: false,
  });
}

export function useSeriesDetail(name, horizon) {
  return useQuery({
    queryKey: ["fx-series-detail", name, horizon],
    queryFn: () => getSeriesDetail(name, horizon),
    enabled: !!name,
    refetchOnWindowFocus: false,
  });
}

export function useBudgets(horizon, enabled = true) {
  return useQuery({
    queryKey: ["fx-budgets", horizon],
    queryFn: () => getBudgets(horizon),
    enabled,
    refetchOnWindowFocus: false,
  });
}

export function useBudgetDetail(id, horizon) {
  return useQuery({
    queryKey: ["fx-budget-detail", id, horizon],
    queryFn: () => getBudgetDetail(id, horizon),
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
}

export function useAllocationSources(horizon, enabled = true) {
  return useQuery({
    queryKey: ["fx-alloc-sources", horizon],
    queryFn: () => getAllocationSources(horizon),
    enabled,
    refetchOnWindowFocus: false,
  });
}
